export interface MessageDay {
  key: string;
  label: string;
}

const dayMonth = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });

function localDayKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/** Chat timestamps are ISO strings. Use the same browser timezone as message times. */
export function messageDayBoundary(createdAt: string, previousCreatedAt?: string, now = new Date()): MessageDay | null {
  const date = new Date(createdAt);
  if (!Number.isFinite(date.valueOf())) return null;
  const key = localDayKey(date);
  if (previousCreatedAt) {
    const previous = new Date(previousCreatedAt);
    if (Number.isFinite(previous.valueOf()) && localDayKey(previous) === key) return null;
  }
  const year = date.getFullYear();
  return { key, label: `${dayMonth.format(date)}${year === now.getFullYear() ? '' : ` ${year}`}` };
}
